import { useEffect, useState } from 'react';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Skeleton, Typography } from '@mui/material';
import AttachFileOutlined from '@mui/icons-material/AttachFileOutlined';
import { AttachmentInfo } from '../../../../../Models/ReWeightingModels/Documents';
import { getReweightingAttachment, getReweightingAttachmentInfo } from '../../../../../Services/LondunarkerfiAPIService';
import AttachmentField from '../../../../../SharedComponents/Documents/AttachmentField';

export default function HarbourAttachmentDialog({ noteId }: { noteId: number }) {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState<{ enabled: boolean; attachment: AttachmentInfo | null }>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [refresh, setRefresh] = useState(0);
  useEffect(() => {
    if (!open) return;
    const abort = new AbortController();
    setLoading(true); setError('');
    getReweightingAttachmentInfo(noteId, abort.signal).then(result => { if (!abort.signal.aborted) setData(result); })
      .catch(() => { if (!abort.signal.aborted) setError('Ekki tókst að sækja upplýsingar um fylgiskjal.'); })
      .finally(() => { if (!abort.signal.aborted) setLoading(false); });
    return () => abort.abort();
  }, [open, noteId, refresh]);
  return <>
    <Button variant="outlined" size="small" startIcon={<AttachFileOutlined />} onClick={() => setOpen(true)}>Fylgiskjal</Button>
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth aria-labelledby="harbour-attachment-title">
      <DialogTitle id="harbour-attachment-title">Fylgiskjal endurvigtunar · Nóta #{noteId}</DialogTitle>
      <DialogContent dividers sx={{ minHeight: 150 }}>
        {loading && !data ? <Box><Skeleton width="50%" height={28} /><Skeleton width="80%" /><Skeleton width={150} height={40} /></Box>
          : error ? <Alert severity="error" action={<Button color="inherit" onClick={() => setRefresh(value => value + 1)}>Reyna aftur</Button>}>{error}</Alert>
            : data?.enabled ? <>
              <AttachmentField attachment={data.attachment} load={() => getReweightingAttachment(noteId)} disabled={loading} />
              {data.attachment && data.attachment.noteId !== noteId && <Typography variant="caption" color="text.secondary">Skjalið fylgdi staðfestum skilum á fyrri nótu #{data.attachment.noteId}.</Typography>}
            </> : <Typography color="text.secondary">Skjalavirkni endurvigtunar hefur ekki verið virkjuð.</Typography>}
      </DialogContent>
      <DialogActions><Button onClick={() => setOpen(false)}>Loka</Button></DialogActions>
    </Dialog>
  </>;
}
